<div class="modal-header">
  <h4 class="modal-title">Encerrar vigência do % Taxa de atualização de garantia</h4>
  <button _ngcontent-jop-c162="" type="button" aria-label="Close" class="btn-close float-end" (click)="fechar()"></button>
</div>
<div class="modal-body">
  <div>
    <div class="mt-3 row">
      <div class="bn-form-group col-md-6">
        <label for="dataInicioValidade"><b>Data Início Validade</b></label>
        <bn-datepicker 
          name="dataInicioValidade" 
          idInput="dataInicioValidade" 
          [(ngModel)]="dataInicioValidade"
          disabled 
        ></bn-datepicker>
      </div>
      <div class="bn-form-group col-md-6">
        <label for="dataFinalValidade"><b>Data Final Validade</b></label>
        <bn-datepicker 
          name="dataFinalValidade" 
          idInput="dataFinalValidade" 
          [(ngModel)]="dataFinalValidade"
          [minDate]="hoje"
        ></bn-datepicker>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary" (click)="fechar()">Cancelar</button>
  <button class="btn btn-primary" [disabled]="!dataFinalValidade || dataFinalValidade < hoje" (click)="salvar()">Salvar</button>
</div>